import React, { createContext, useState } from "react";

interface InputContextType {
  initialMessage: string;
  setInitialMessage: (msg: string) => void;
  initialMessageDisplay: string;
  initialMessageBackend: string;
  setInitialMessages: (display: string, backend: string) => void;
  initialAudio: Blob | null;
  setInitialAudio: (blob: Blob | null) => void;
}

export const InputContext = createContext<InputContextType | undefined>(
  undefined
);

export const InputProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [initialMessage, setInitialMessageState] = useState<string>("");
  const [initialMessageDisplay, setInitialMessageDisplay] =
    useState<string>("");
  const [initialMessageBackend, setInitialMessageBackend] =
    useState<string>("");
  const [initialAudio, setInitialAudio] = useState<Blob | null>(null);

  // Helper function to set both display and backend messages
  // If only one is provided, use it for both (backward compatibility)
  const setInitialMessages = (display: string, backend: string) => {
    setInitialMessageDisplay(display);
    setInitialMessageBackend(backend);
    // Keep initialMessage for backward compatibility (use display version)
    setInitialMessageState(display);
  };

  // Wrapper for setInitialMessage that also sets display and backend
  // This maintains backward compatibility while supporting the new dual-message system
  const setInitialMessage = (msg: string) => {
    setInitialMessageState(msg);
    setInitialMessageDisplay(msg);
    setInitialMessageBackend(msg);
  };

  return (
    <InputContext.Provider
      value={{
        initialMessage,
        setInitialMessage,
        initialMessageDisplay,
        initialMessageBackend,
        setInitialMessages,
        initialAudio,
        setInitialAudio
      }}
    >
      {children}
    </InputContext.Provider>
  );
};

export default InputProvider;
